import { RouteLocationRaw } from 'vue-router';

export function isExternalLink(linkTarget: RouteLocationRaw): boolean {
    return (
        typeof linkTarget === 'string' &&
        (linkTarget.startsWith('http://') ||
            linkTarget.startsWith('https://') ||
            linkTarget.startsWith('onenote:http://') ||
            linkTarget.startsWith('onenote:https://'))
    );
}
